<div class="modal fade0" id="pmodal" tabindex="-1" role="dialog" aria-labelledby="pmodalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document" style="width:97%; max-width:initial">
        <div class="modal-content" style="padding:20px">

            <div class="card card-primary">
                <div class="card-header" *ngIf="service.model">
                    {{service.model.model.tit}}
                </div>
                <div class="card-body" style="background-color: #f9f9fb;">

                    <div *ngFor="let mdls of layout; let ig=index;" class="row" style="margin-top:2rem">
                        <div *ngFor="let mdl of mdls; let i=index;" [class]="'col '+(mdl.clsp||'')">

                            <!----- normal ------------------------------>
                            <ng-container *ngIf="!is_array(mdl)">
                                <!-- <app-chtm *ngIf="mdl.dis==2 && mdl.ctyp=='chtm'" [model]="mdl"></app-chtm> -->
                                <app-grid *ngIf="condition_gridform(mdl, 1)" [model]="mdl"></app-grid>
                                <app-formy *ngIf="condition_gridform(mdl, 2)" [model]="mdl"></app-formy>
                                <!-- <app-chart *ngIf="mdl.dis==2 && mdl.ctyp=='chart'" [model]="mdl"></app-chart> -->
                                <app-treev *ngIf="mdl.dis==2 && mdl.ctyp=='treev'" [model]="mdl"></app-treev>
                                <!-- <app-grid *ngIf="mdl.dis==2 && mdl.ctyp=='calen'" [model]="mdl"></app-grid> -->
                            </ng-container>

                            <!----- nav --------------------------------->
                            <ul *ngIf="is_array(mdl)" class="nav nav-tabs">
                                <li *ngFor="let md of mdl; let i=index" class="nav-item">
                                    <a class="nav-link" id="{{'tab-menu'+md.id}}" data-toggle="tab"
                                        href="#menu{{md.id}}" role="tab" aria-selected="false"
                                        style="padding-left:30px; padding-right:30px">{{md.tit}}</a>
                                </li>
                            </ul>
                            <div *ngIf="is_array(mdl)" class="tab-content">
                                <br><br>
                                <div id="menu{{md.id}}" *ngFor="let md of mdl; let i=index" class="tab-pane"
                                    role="tabpanel">
                                    <!-- <app-chtm *ngIf="md.ctyp=='chtm'" [model]="md"></app-chtm> -->
                                    <app-grid *ngIf="md.ctyp=='grid'" [model]="md"></app-grid>
                                    <app-formy *ngIf="md.ctyp=='formy'" [model]="md"></app-formy>
                                    <!-- <app-chart *ngIf="md.ctyp=='chart'" [model]="md"></app-chart> -->
                                    <app-treev *ngIf="md.ctyp=='treev'" [model]="md"></app-treev>
                                    <!-- <app-grid *ngIf="md.ctyp=='calen'" [model]="md"></app-grid> -->
                                </div>
                            </div>
                        </div>
                    </div>






                </div>
                <div class="card-footer">
                    <button type="button"
                        *ngIf="service.model && service.model.model.dis==5 && service.model.model.ctyp=='grid'"
                        class="btn btn-secondary" (click)="service.unimplement()"> &nbsp; انصراف &nbsp; </button>
                    &nbsp;
                    <button type="button"
                        *ngIf="service.model && service.model.model.dis==5 && service.model.model.ctyp=='grid'"
                        class="btn btn-success" (click)="service.apply()"> &nbsp; تایید &nbsp; </button>
                </div>
            </div>
        </div>
    </div>
</div>